// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panelContent[data-v-a2461856] {\n  height: calc(100% - 0.22396rem);\n  color: #fff;\n}\n.lefts[data-v-a2461856] {\n  height: 30%;\n  margin-bottom: 0.05208rem;\n}\n.lefts2[data-v-a2461856] {\n  height: calc(70% - 0.05208rem);\n}\n@media (min-height: 1400px) {\n.rightBar[data-v-a2461856] .side {\n    width: 24% !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
